<template>
  <IconLucidePlay />
</template>
